module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Home</title><path d=M1008.14,519.53,555.83,67.12a62.19,62.19,0,0,0-87.66-.06L15.86,519.56c-24.12,24.12-15.94,44,18.17,44H143.45V909.46c0,35.93,29.55,65.52,65.49,65.52H403.43V718H622.57V975h257V563.59H990C1024.08,563.59,1032.26,543.67,1008.14,519.53Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/mini-apps/app-switcher/icons/home.svg
// module id = 196
// module chunks = 0